import { render, staticRenderFns } from "./TmcHome.vue?vue&type=template&id=35d48562&scoped=true&"
import script from "./TmcHome.vue?vue&type=script&lang=js&"
export * from "./TmcHome.vue?vue&type=script&lang=js&"
import style0 from "./TmcHome.vue?vue&type=style&index=0&id=35d48562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d48562",
  null
  
)

export default component.exports